module.exports = __webpack_public_path__ + "static/buzzfeed@2x-f3fe92c65444fdd24722645ecfe2e4f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/buzzfeed@2x.jpg
// module id = 864
// module chunks = 33019919093843 122353984331245